import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, CircularProgress, FormControlLabel, TextField, Container, Typography, InputLabel, FormLabel, Paper, Toolbar, Select, MenuItem, Divider, Radio, RadioGroup, Button, Grid, Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { AcquirerActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const acquirersSelector = (state) => state.Acquirers;
const IdentitySelector = (state) => state.Identity;

const AcquirerEdit = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const acquirerActions = bindActionCreators(AcquirerActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(acquirersSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch } = useForm();

    const { classes } = props;

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 申請ボタン押下時の処理
     * 
     */
    const onSubmit = (data, e) => {
        acquirerActions.apply(token, editing)
            .then(data => {
                notificationActions.showSuccess('申請しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        return value;
    }

    if (editing == null) {
        return <div></div>;
    }

    // 代表加盟店入力チェック値
    var shopCd1Pattern = /[0-9]{13}/i;
    var shopCd1MaxLength = 13;
    var shopCd2Pattern = /[0-9]{4}/i;
    var shopCd2MaxLength = 4;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Acquirer.Create" />}</Typography>
                    </div>
                </Toolbar>
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Controller
                                name="contact_name"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerContactNameMaxLenPattern" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.contact_name && true}
                                    type="text"
                                    helperText={errors.contact_name ? errors.contact_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄太郎</Typography>}
                                    label={<FormattedMessage id={"Merchant.ContactName"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="contact_f_name"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerContactNameMaxLenPattern" />}</Typography> },
                                    pattern: { value: /^[ァ-ヶー０-９]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.KatakanaName" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.contact_f_name && true}
                                    type="text"
                                    helperText={errors.contact_f_name ? errors.contact_f_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} オキナワタロウ</Typography>}
                                    label={<FormattedMessage id={"Merchant.ContactNameInFurigana"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="contact_tel"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    minLength: { value: 10, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerTelMinLenPattern" />}</Typography> },
                                    maxLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerTelMaxLenPattern" />}</Typography> },
                                    pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.HankakuNumber" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.contact_tel && true}
                                    helperText={errors.contact_tel ? errors.contact_tel.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0975768181</Typography>}
                                    label={<FormattedMessage id={"Merchant.PhoneNumber"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="mail_adress"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 256, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerEmailMaxLenPattern" />}</Typography> },
                                    pattern: { value: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Email" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.mail_adress && true}
                                    type="email"
                                    helperText={errors.mail_adress ? errors.mail_adress.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} okinawa_taro@co.jp</Typography>}
                                    label={<FormattedMessage id={"Merchant.MailAddress"} />} />} />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined" error={errors.business_form && true}>
                                <InputLabel id="merchant-business-form"><FormattedMessage id={"Merchant.BusinessForm"} /></InputLabel>
                                <Controller
                                    name="business_form"
                                    control={control}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    onChange={onChange}
                                    as={<Select
                                        labelId="merchant-business-form"
                                        id="merchant-business-type"
                                        label={<FormattedMessage id={"Merchant.BusinessForm"} />}>
                                        <MenuItem value={1}><FormattedMessage id="Merchant.Corporate" /></MenuItem>
                                        <MenuItem value={2}><FormattedMessage id="Merchant.IndividualBusiness" /></MenuItem>
                                    </Select>} />
                                <FormHelperText>{errors.business_form ? errors.business_form.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="corporat_name"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerCorporatNameMaxLenPattern" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.corporat_name && true}
                                    type="text"
                                    helperText={errors.corporat_name ? errors.corporat_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄ICカード株式会社</Typography>}
                                    label={<FormattedMessage id={"Merchant.CorporateName"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="corporat_f_name"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerCorporatNameMaxLenPattern" />}</Typography> },
                                    pattern: { value: /^[ァ-ヶー０-９]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.KatakanaName" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField fullWidth variant="outlined"
                                    error={errors.corporat_f_name && true}
                                    type="text"
                                    helperText={errors.corporat_f_name ? errors.corporat_f_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} オキナワアイシーカードカブシキガイシャ</Typography>}
                                    label={<FormattedMessage id={"Merchant.CorporateNameInFurigana"} />} />} />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="corporat_no"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    minLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerCorporatNoMinLenPattern" />}</Typography> },
                                    maxLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerCorporatNoMaxLenPattern" />}</Typography> },
                                    pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.HankakuNumber" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.corporat_no && true}
                                    type="text"
                                    helperText={errors.corporat_no ? errors.corporat_no.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 236000101759</Typography>}
                                    label={<FormattedMessage id={"Merchant.CorporateNumber"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="shop_cd_1"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: shopCd1MaxLength, message: <Typography component="h6">{<FormattedMessage id="Error.ShopCd1_Pattern" />}</Typography> },
                                    pattern: { value: shopCd1Pattern, message: <Typography component="h6"><FormattedMessage id={"Error.ShopCd1_Pattern"} /></Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.shop_cd_1 && true}
                                    type="text"
                                    helperText={errors.shop_cd_1 ? errors.shop_cd_1.message : <Typography component="h6">※ {<FormattedMessage id="Label.ShopCd1" />}</Typography>}
                                    label={<FormattedMessage id={"Merchant.StoreCodeLevel1"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="shop_cd_2"
                                control={control}
                                defaultValue={editing.shop_cd_2}
                                rules={{
                                    maxLength: { value: shopCd2MaxLength, message: <Typography component="h6">{<FormattedMessage id="Error.ShopCd2_Pattern" />}</Typography> },
                                    pattern: { value: shopCd2Pattern, message: <Typography component="h6"><FormattedMessage id={"Error.ShopCd2_Pattern"} /></Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField fullWidth variant="outlined"
                                    error={errors.shop_cd_2 && true}
                                    type="text"
                                    helperText={errors.shop_cd_2 ? errors.shop_cd_2.message : <Typography component="h6">※ {<FormattedMessage id="Label.ShopCd2" />}</Typography>}
                                    label={<FormattedMessage id={"Merchant.StoreCodeLevel2"} />} />} />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined" error={errors.shop_cd_type && true}>
                                <InputLabel id="merchant-shop-code-type"><FormattedMessage id={"Merchant.CorporateCodeType"} /></InputLabel>
                                <Controller
                                    name="shop_cd_type"
                                    control={control}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    onChange={onChange}
                                    as={<Select
                                        required
                                        labelId="merchant-shop-code-type"
                                        id="merchant-shop-code"
                                        label={<FormattedMessage id={"Merchant.CorporateCodeType"} />}>
                                        <MenuItem value={1}><FormattedMessage id="Merchant.CorporateCodeTypeOkica" /></MenuItem>
                                        {/* 2020.09.30 JPQR未対応 */}
                                        {/*<MenuItem value={2}><FormattedMessage id="Merchant.CorporateCodeTypeJPQR" /></MenuItem>*/}
                                    </Select>} />
                                <FormHelperText>{errors.shop_cd_type ? errors.shop_cd_type.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="merchant_name"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 25, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerMerchantNameMaxLenPattern" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.merchant_name && true}
                                    type="text"
                                    helperText={errors.merchant_name ? errors.merchant_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄タクシー</Typography>}
                                    label={<FormattedMessage id={"Merchant.Name"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="merchant_e_name"
                                control={control}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 100, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerMerchantEnglishNameMaxLenPattern" />}</Typography> },
                                    pattern: { value: /^[0-9a-zA-Z ._-]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Hankakueisu" />}</Typography> }
                                }}
                                onChange={onChange}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.merchant_e_name && true}
                                    type="text"
                                    helperText={errors.merchant_e_name ? errors.merchant_e_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} OkinawaTaxi</Typography>}
                                    label={<FormattedMessage id={"Merchant.NameInEng"} />} />} />
                        </Grid>

                        <Grid item xs>
                            <Button fullWidth variant="contained" size="medium"
                                startIcon={<ArrowBackIosIcon />}
                                onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                        </Grid>
                        <Grid item xs>
                            <Button fullWidth variant="contained" size="medium" color="primary"
                                onClick={handleSubmit(onSubmit)}
                                endIcon={<SaveIcon />}><FormattedMessage id="Button.Application" /></Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(AcquirerEdit);
